@if (isEnabled) {
    <ul class="h-product-nav tab-nav navbar-nav global-search-placeholder">
        <li class="tab-nav-item nav-item" (click)="showsearch()">
            @if (canDisplayIcon) {
                <span [ngClass]="desktopClass"></span>
            }
        </li>
    </ul>
}
